export class CommonLibrary {
     static formatDateIntoString(date: Date | string) {
        if (date == null) return "";
        let dateObj = typeof date === "string" ? new Date(date) : date;
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        const year = dateObj.getFullYear().toString();
        return `${month}/${day}/${year}`;
    }

    static downloadImageByUrl(imageUrl: string, fileName: string) {
        let element = document.createElement('a');
        element.href = imageUrl;
        element.download = fileName.replace(/[\s.]+/g, '');
        element.click();
    }

    static formatStatusIntoString(status: number) {
        switch (status) {
            case 0:
                return "Pending";
            case 1:
                return "Approved";
            case 2:
                return "Denied";
            default:
                return "N/A";
        }
    }

    static getMembershipPriceForLevel(valString, employeeCount) {
        var val: number = +valString
        switch (val) {
            case 1:
                switch (+employeeCount) {
                    case 1:
                        return "$499.00";
                    case 2:
                        return "$644.00";
                    case 3:
                        return "$825.00";
                    case 4:
                        return "$1,040.00";
                    case 5:
                        return "$1,319.00";
                    case 6:
                        return "$1,689.00";
                    case 7:
                        return "$2,453.00";
                    case 8:
                        return "$3,317.00";
                    case 9:
                        return "$4,960.00";
                    case 10:
                        return "This price is negotiated individually.";
                }
                break;
            case 2:
                switch (+employeeCount) {
                    case 1:
                        return "$792.00";
                    case 2:
                        return "$968.00";
                    case 3:
                        return "$1,238.00";
                    case 4:
                        return "$1,562.00";
                    case 5:
                        return "$1,979.00";
                    case 6:
                        return "$2,536.00";
                    case 7:
                        return "$3,680.00";
                    case 8:
                        return "$4,978.00";
                    case 9:
                        return "$7,442.00";
                    case 10:
                        return "This price is negotiated individually.";
                }
                break;
            case 4:
                return "Starting at $5,500";
            case 5:
                return "Starting at $11,000";
            case 6:
                return "Starting at $27,500";
            case 7:
                return "Starting at $55,000";
            case 9:
                return "TBD";
            case 12:
                return "$300";
            default:
                return "";
        }
        return "";
    }
    static getStartupPricing(valString) {
        var val: number = + valString
        switch (val) {
            case 1:
                return "$0";
            case 2:
                return"$87";
            case 3:
                return"$165";
            default:
                return "";
        }
        return "";
    }
    static GetFileIconClass(fileType: string) {
        if (fileType.includes('pdf')) {
            return 'fa-file-pdf';
        }
        else if (fileType.includes('image')) {
            return 'fa-file-image';
        }
        else {
            return 'fa-file';
        }
    }
}